<template>
    <span class="isolate inline-flex rounded-md shadow-sm">
        <button @click="delItem(link.id)" type="button" class="buttonsetup">
            <MinusCircleIcon class="-ml-0.5 h-5 w-5 text-primary-400" aria-hidden="true" />
        </button>
        <button @click="addItem(link.id)" type="button" class="buttonsetup" v-if="props.link.mode == 'group'">
            <PlusCircleIcon class="-ml-0.5 h-5 w-5 text-primary-400" aria-hidden="true" />
        </button>
        <span type="button" class="buttonsetup">
            <SwitchButton :enabled="props.link.active" @update="(res) => editActive(res, link.id)" />
        </span>
    </span>
</template>
<style>
.buttonsetup {
    @apply relative inline-flex items-center gap-x-1.5 rounded-l-md  px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-secondary-400 hover:bg-secondary-400 focus:z-10
}
</style>
<script setup>
import { defineProps, defineEmits } from 'vue';
import { PlusCircleIcon, MinusCircleIcon} from '@heroicons/vue/20/solid';
const props = defineProps(['link'])
const emit = defineEmits(['delItem', 'addItem', 'editActive'])
import SwitchButton from './Switch-Button.vue'

const delItem = res => {
    emit('delItem', res)
}
const addItem = res => {
    emit('addItem', res)
}

const editActive = (res, id) => {
    emit('editActive', [res, id])
}
</script>